import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import Base from '../Select'

export const GET_USERS = gql`
  {
    users {
      id
      firstName
      lastName
      role
    }
  }
`

const Select = ({...others}) => {
  return (
    <Query query={GET_USERS} fetchPolicy='cache-and-network'>
      {({data}) =>
        <Base {...others}>
          <optgroup label='Admin'>
            {data && data.users && data.users.filter(u => u.role === 'ADMIN').map(u =>
              <option key={u.id} value={u.id}>{`${u.firstName} ${u.lastName}`}</option>
            )}
          </optgroup>
          <optgroup label='Sales Rep'>
            {data && data.users && data.users.filter(u => u.role === 'SALES').map(u =>
              <option key={u.id} value={u.id}>{`${u.firstName} ${u.lastName}`}</option>
            )}
          </optgroup>
          <optgroup label='Client'>
            {data && data.users && data.users.filter(u => u.role === 'CLIENT').map(u =>
              <option key={u.id} value={u.id}>{`${u.firstName} ${u.lastName}`}</option>
            )}
          </optgroup>
        </Base>
      }
    </Query>
  )
}

export default Select


// WEBPACK FOOTER //
// ./src/components/Users/Select.js